import { useReveal } from "@/hooks/useReveal";

const PRODUCTS = [
  {
    image:
      "https://storage.helloreaddy.io/project_files/1d5eebb5-cdd6-4798-a44f-e501204aaa58/2166d376-6afb-442b-9720-7178abe61a0b_compressed_organic-unrefined-whole-cane-sugar-2.webp",
    alt: "Close-up of raw golden-brown unrefined whole cane sugar crystals",
    title: "Organic unrefined whole cane sugar",
    body: "Cane juice evaporated without centrifuging, so the natural molasses and minerals stay in the crystal. Available pulverised, granulated and in single-serve sachets. Supplied in retail packs, foodservice formats and bulk.",
    akaLabel: "Also known as:",
    tags: [
      "non-centrifugal cane sugar (NCS)",
      "whole cane sugar",
      "unrefined cane sugar",
      "muscovado-type",
      "jaggery",
      "panela (Latin America)",
    ],
  },
  {
    image:
      "https://storage.helloreaddy.io/project_files/1d5eebb5-cdd6-4798-a44f-e501204aaa58/b58550ea-1848-4832-865a-44eee513d346_compressed_organic-cocoa-powder.webp",
    alt: "Close-up of dark cocoa powder with fine texture",
    title: "Organic cocoa powder",
    body: "Pure cocoa powder at 15% fat content, with stable specification batch to batch. Supplied in retail packs, 25 kg bulk and in your own brand. Cocoa butter, nibs and cocoa shell available on request.",
    akaLabel: null,
    tags: ["15% fat", "no added sugar", "batch CoA", "bulk or packed"],
  },
];

export default function Products() {
  const headingRef = useReveal<HTMLDivElement>();
  const gridRef = useReveal<HTMLDivElement>();
  const noteRef = useReveal<HTMLDivElement>();

  return (
    <section id="products" className="bg-white py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div ref={headingRef} className="reveal">
          <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold">
            What we produce
          </h2>
        </div>

        <div ref={gridRef} className="reveal mt-12 grid grid-cols-1 md:grid-cols-2 gap-8">
          {PRODUCTS.map((product) => (
            <article
              key={product.title}
              className="flex flex-col rounded-lg overflow-hidden border border-cream-dark/70 bg-white"
            >
              <div className="w-full h-64 md:h-72 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.alt}
                  loading="lazy"
                  className="w-full h-full object-cover object-top transition-transform duration-500 hover:scale-105"
                />
              </div>
              <div className="p-7 md:p-8 flex flex-col flex-1">
                <h3 className="text-ink font-serif text-2xl font-semibold">
                  {product.title}
                </h3>
                <p className="mt-4 text-ink/70 text-[17px] leading-relaxed">
                  {product.body}
                </p>

                <div className="mt-6 flex flex-wrap items-center gap-2">
                  {product.akaLabel && (
                    <span className="text-ink/60 text-sm mr-1">
                      {product.akaLabel}
                    </span>
                  )}
                  {product.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-3 py-1.5 rounded-full bg-cream text-brown text-sm font-medium whitespace-nowrap"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>

        <p
          ref={noteRef}
          className="reveal mt-10 text-center text-ink/60 text-base max-w-2xl mx-auto"
        >
          Specialty coffee, herbal infusions and spices are available to
          consolidate a mixed container.
        </p>
      </div>
    </section>
  );
}